import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyService } from '../../services/privacy.service';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (showBanner) {
      <div 
        [@slideUp]
        class="fixed bottom-6 left-6 right-6 md:left-auto md:max-w-md bg-white/95 backdrop-blur-md border border-gray-200 rounded-2xl shadow-2xl p-6 z-[9999]">
        <div class="flex flex-col gap-4">
          <div class="flex items-start gap-4">
            <div class="p-3 bg-primary/10 rounded-xl">
              <span class="material-icons text-primary text-2xl">cookie</span>
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-bold text-gray-900 mb-1">We value your privacy</h3>
              <p class="text-gray-600 text-sm leading-relaxed">
                We use cookies to enhance your experience, analyze site traffic, and support our marketing efforts. 
                By clicking "Accept All", you consent to our use of cookies.
              </p>
            </div>
          </div>
          
          <div class="flex flex-col sm:flex-row gap-3 pt-2">
            <button 
              (click)="acceptAll()"
              class="flex-1 px-6 py-3 bg-primary text-white font-semibold rounded-xl hover:bg-primary-dark transition-all duration-300 shadow-md">
              Accept All
            </button>
            <button 
              (click)="rejectAll()"
              class="flex-1 px-6 py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all duration-300">
              Reject All
            </button>
          </div>
          
          <div class="text-center">
            <a href="https://www.regenesis.ag/privacy-policy" target="_blank" class="text-xs text-primary hover:underline font-medium">Read our Privacy Policy</a>
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    :host {
      display: block;
    }
    .bg-primary { background-color: #3B43FD; }
    .text-primary { color: #3B43FD; }
    .bg-primary-dark { background-color: #2D34E5; }
  `],
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('500ms cubic-bezier(0.23, 1, 0.32, 1)', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('400ms cubic-bezier(0.23, 1, 0.32, 1)', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class CookieConsentComponent implements OnInit {
  private readonly privacyService = inject(PrivacyService);
  showBanner = false;

  ngOnInit(): void {
    if (!this.privacyService.consent()) {
      setTimeout(() => {
        this.showBanner = true;
      }, 1000);
    }
  }

  acceptAll() {
    this.privacyService.setConsent({
      cookies: true,
      location: true,
      marketing: true
    });
    this.showBanner = false;
  }

  rejectAll() {
    this.privacyService.setConsent({
      cookies: false,
      location: false,
      marketing: false
    });
    this.showBanner = false;
  }
}
